// Contact information data
export const contactInfo = {
  address: "Road No. 5712, Jaww, Bahrain",
  email: "info@nairdc.bh",
  phone: "+973 1711 1171",
};

// Contact form placeholders
export const contactForm = {
  title: "Leave a Message!",
  namePlaceholder: "Full name",
  phonePlaceholder: "Phone number",
  emailPlaceholder: "Email Address",
  messagePlaceholder: "Tell us about your organization.",
  submitButton: "Send",
};
